var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardsTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:cards"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8917 3.625L16.775 3.15833V10.6833L18.8 5.8C19.1417 4.95 18.75 3.975 17.8917 3.625ZM1.64169 6.70833L5.77502 16.6667C5.89674 16.9697 6.10435 17.2305 6.37233 17.417C6.64031 17.6036 6.95696 17.7077 7.28336 17.7167C7.50002 17.7167 7.72502 17.675 7.94169 17.5833L14.0834 15.0417C14.7084 14.7833 15.0917 14.1667 15.1084 13.55C15.1167 13.3333 15.075 13.0917 15 12.875L10.8334 2.91667C10.7156 2.61168 10.5087 2.34922 10.2397 2.16343C9.97067 1.97764 9.65196 1.87714 9.32502 1.875C9.10836 1.875 8.89169 1.925 8.68336 2L2.55002 4.54167C2.14233 4.70862 1.81762 5.03065 1.64729 5.43694C1.47695 5.84324 1.47494 6.30055 1.64169 6.70833ZM15.1 3.54167C15.1 3.09964 14.9244 2.67572 14.6119 2.36316C14.2993 2.05059 13.8754 1.875 13.4334 1.875H12.225L15.1 8.825",
    fill: "white",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsTab);
export default __webpack_public_path__ + "static/media/CardsTab.a0bad8bb0f8828cbd80fb46bacb0a874.svg";
export { ForwardRef as ReactComponent };